import axios from "axios";

/**
 * Hapus seluruh cookies di browser (domain saat ini, parent domain, dan path root).
 */
export function clearAllCookies() {
  try {
    const cookies = document.cookie ? document.cookie.split(";") : [];
    const hostname = window.location.hostname;
    const domainParts = hostname.split(".");

    // Daftar nama cookie yang umum dipakai di aplikasi Laravel & SPA
    const commonCookieNames = [
      "token",
      "jwt",
      "access_token",
      "access_token_peserta",
      "access_token_penilai",
      "session",
      "laravel_session",
      "XSRF-TOKEN",
      "remember_web",
    ];

    const allCookieNames = new Set(commonCookieNames);

    cookies.forEach((cookie) => {
      const eqPos = cookie.indexOf("=");
      const name = eqPos > -1 ? cookie.substring(0, eqPos).trim() : cookie.trim();
      if (name) allCookieNames.add(name);
    });

    const paths = ["/", window.location.pathname];
    const domains = ["", hostname, `.${hostname}`];

    if (domainParts.length > 2) {
      const rootDomain = domainParts.slice(-2).join(".");
      domains.push(rootDomain, `.${rootDomain}`);
    }

    allCookieNames.forEach((name) => {
      paths.forEach((p) => {
        domains.forEach((d) => {
          const domainAttr = d ? `; domain=${d}` : "";
          document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=${p}${domainAttr}`;
          document.cookie = `${name}=; max-age=0; path=${p}${domainAttr}`;
        });
      });
    });
  } catch (e) {
    console.warn("Gagal membersihkan cookies:", e);
  }
}

/**
 * Hapus cache browser jika Cache API didukung.
 */
export async function clearAllCaches() {
  try {
    if (window.caches && window.caches.keys) {
      const cacheNames = await window.caches.keys();
      await Promise.all(cacheNames.map((name) => window.caches.delete(name)));
    }
  } catch (e) {
    console.warn("Gagal membersihkan cache:", e);
  }
}

/**
 * Bersihkan seluruh data session di client (localStorage, sessionStorage, cookies, cache, dan axios headers).
 */
export function clearClientSession() {
  const keys = [
    "session_user_id",
    "session_username",
    "session_name",
    "session_path_photo",
    "session_role",
    "session_role_active_id",
    "session_role_active_name",
    "session_role_active_index",
    "session_menu_access",
    "session",
    "user",
    "configuration",
    "reload_already",
    "dateLogin",
    "roles_data_akses_menu",
    "roles_data_akses_kode_tes",
    "is_validator",
    "is_penyusunSoal",
    "isWrite",
    "isRead",
    "menu_read_names",
    "menu_write_names",
    "kode_tes_active",
    "user_pegawai",
    "filtered_menu",
    "filtered_name_menu",

    // legacy cleanup
    "access_token",
    "access_token_penilai",
    "access_token_peserta",
  ];

  try {
    keys.forEach((key) => localStorage.removeItem(key));
    localStorage.clear();
  } catch (e) {
    console.warn("Gagal membersihkan localStorage:", e);
  }

  try {
    sessionStorage.clear();
  } catch (e) {
    console.warn("Gagal membersihkan sessionStorage:", e);
  }

  try {
    if (axios && axios.defaults && axios.defaults.headers) {
      if (axios.defaults.headers.common) {
        delete axios.defaults.headers.common["Authorization"];
        delete axios.defaults.headers.common["X-XSRF-TOKEN"];
      }
    }
  } catch (e) {
    // ignore
  }

  clearAllCookies();
  clearAllCaches();
}


